import React from 'react'
import MainLayout from '../../layouts/Main'
import { MainCarousel } from '../../components'
import './styles.css'

import PublicationsBlock from './publications.block'
import EShopBlock from './e-shop.block'
import TravelsBlock from './travels.block'
import FoundationBlock from './foundation.block'

const HomePageView = () => {
    return (
        <MainLayout>
            <div className="row">
                <div className="col-sm-12">
                    <MainCarousel/>
                </div>
            </div>
            <PublicationsBlock />
            <hr/>
            <EShopBlock />
            <hr/>
            <TravelsBlock />
            <hr/>
            <FoundationBlock />
        </MainLayout>
    )
}

HomePageView.propTypes = {
    
}

export default HomePageView



// WEBPACK FOOTER //
// ./src/views/Home/index.js